import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=1422e40e&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"
import style0 from "./ContactModal.vue?vue&type=style&index=0&id=1422e40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422e40e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
